import RegisteredTrademarkIcon from './component'

export default RegisteredTrademarkIcon


// WEBPACK FOOTER //
// ./src/components/RegisteredTrademarkIcon/index.js